import { GovernanceCheckEdit } from '@client/components/mspr/governance-check-edit';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/workload-manager/tasks/calendar/details/msp_governance_check/$id',
)({
    staticData: {
        metadata: {
            title: 'Governance check details',
        },
        presentation: 'overlay',
    },
    params: {
        parse({ id }) {
            return { id: BigInt(id) };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { id } = Route.useParams();
    const { trpc } = useTrpc();

    // Get the workload item to find the provider ID
    const { data: workloadItem } = trpc.workloadManager.listWorkloadItems.useQuery({
        where: { id, workItemType: 'msp_governance_check' },
        limit: 1,
        offset: 0,
    });

    const item = workloadItem?.rows[0];

    if (!item) {
        return null;
    }

    return (
        <GovernanceCheckEdit
            action={['edit', id, item.recordId ?? BigInt(0)]}
            onClose={() => window.history.back()}
            workloadItem={item}
        />
    );
}
